import { askQuestionWithDialog } from 'features/dialogs/askQuestionWithDialog'
import ConfirmDialog, { ConfirmDialogProps, ConfirmDialogResult } from './ConfirmDialog'

export type ConfirmWithDialogProps = Omit<ConfirmDialogProps, 'open' | 'onResult' | 'onClose' | 'children'> & {
  message: string
}

const ConfigDialogWrapper = ({
  onResponse,
  open,
  message,
  onClose,
  ...otherProps
}: {
  onResponse: (result: ConfirmDialogResult) => void
  open: boolean
  onClose: () => void
  message: string
} & Omit<ConfirmDialogProps, 'onResult' | 'children'>) => {
  return (
    <ConfirmDialog
      {...otherProps}
      onResult={(result) => {
        onResponse(result)
        onClose()
      }}
      open={open}
    >
      {message}
    </ConfirmDialog>
  )
}
export async function confirmWithDialog(props: ConfirmWithDialogProps) {
  const configDialogFactory = async () => ({
    default: ConfigDialogWrapper
  })
  const result = await askQuestionWithDialog(configDialogFactory, props)
  return result
}
